function buildGoodsArray(arr){
	let array=[];
	arr.forEach(function(i){
		array.push(new BuildGood(i));
	});
	return array;
};

function BuildGood(arr){
	this.name=arr[0];
	this.material=arr[1];
	this.height=arr[2];
	this.diametr=arr[3];
	this.amount=arr[4];
	this.price=arr[5];
	this.img=arr[6];
}
export default buildGoodsArray
export {BuildGood}